import { useState } from "react";
import axios from "axios";
import { DatabaseBackup, Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "mra_jwt";

const filenameFrom = (headers, fallback) => {
  const m = /filename="?([^";]+)"?/.exec(headers?.["content-disposition"] || "");
  return m ? m[1] : fallback;
};

/** One-tap full database backup (mongorestore-compatible zip) for admins. */
export const BackupDownloadButton = () => {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const token = localStorage.getItem(TOKEN_KEY);
      const res = await axios.get(`${API}/admin/backup/mongodump`, {
        responseType: "blob",
        withCredentials: true,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = filenameFrom(res.headers, "mra-backup.zip");
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success("Database backup downloaded.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't build the backup. Try again in a moment.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={download}
      disabled={busy}
      data-testid="admin-backup-download"
      title="Downloads every collection as a mongorestore-compatible zip"
      className="inline-flex items-center gap-2 self-stretch rounded-xl border border-border bg-bone px-4 py-3 text-sm font-semibold text-ink transition-colors hover:border-ink disabled:opacity-60"
    >
      {busy ? (
        <Loader2 className="h-4 w-4 animate-spin" strokeWidth={2.2} />
      ) : (
        <DatabaseBackup className="h-4 w-4" strokeWidth={2} />
      )}
      {busy ? "Building backup…" : "Download database backup"}
    </button>
  );
};
